// Lectures à la demande dans SYNC (onglets Écarts et Achats de la fiche) et commentaires persistés.

import { z } from 'zod';

/** Facturé client et charges comptabilisées un mois donné (la MO n'existe qu'en cumul). */
export interface OpsMonthLine {
  m: string;
  f: number;
  a: number;
  s: number;
  p: number;
}

/** Commandes d'achat non facturées (engagé), réparties achats / sous-traitance. */
export interface OpsEcarts {
  engage: { a: number; s: number };
  months: OpsMonthLine[];
}

export interface OpsOrder {
  o: string;
  d: string | null;
  f: string | null;
  ds: string | null;
  ach: string | null;
  st: string | null;
  sr: string | null;
  isST: boolean;
  /** Commandé, facturé par le fournisseur, reste à facturer. */
  m: number | null;
  fv: number;
  u: number | null;
  /** Écart facture = facturé + reste − commandé (positif : le fournisseur facture plus que la commande). */
  ecart: number | null;
  nf: number;
  rc: string | null;
  cm: string | null;
  /** Factures fournisseurs rattachées au chantier sans commande correspondante. */
  orphan: boolean;
}

export interface OpsInvoice {
  n: string;
  t: string | null;
  d: string;
  ds: string | null;
  v: number;
}

export interface OpsAchats {
  orders: OpsOrder[];
  invoices: OpsInvoice[];
}

export interface OpsOrderLine {
  l: string;
  art: string | null;
  ds: string | null;
  acc: string | null;
  q: number;
  pu: number;
  m: number;
  /** Quantité, prix unitaire moyen et montant facturés ; écart = facturé − commandé pour la quantité facturée. */
  qf: number | null;
  puf: number | null;
  vf: number | null;
  ecart: number | null;
  /** Ligne de facture sans ligne de commande. */
  extra?: { n: string; d: string };
}

export const COMMENT_KINDS = ['Décision', 'Action', 'Commentaire'] as const;
export type CommentKind = (typeof COMMENT_KINDS)[number];

export const OpsCommentInputSchema = z.object({
  kind: z.enum(COMMENT_KINDS),
  text: z
    .string()
    .trim()
    .min(1, 'Saisissez un texte.')
    .max(1000, 'Le texte ne peut pas dépasser 1 000 caractères.'),
  /** Actions seulement : responsable et échéance. */
  resp: z.string().trim().max(80).optional(),
  due: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
});
export type OpsCommentInput = z.infer<typeof OpsCommentInputSchema>;

export const OpsCommentDoneSchema = z.object({ done: z.boolean() });

export interface OpsCommentDto {
  id: string;
  code: string;
  kind: CommentKind;
  text: string;
  resp: string | null;
  due: string | null;
  done: boolean;
  doneOn: string | null;
  author: string;
  createdAt: string;
}

/** Un code d'affaire ou de commande Flex : lettres, chiffres, tiret, soulignement. */
export const OPS_CODE = /^[A-Za-z0-9_-]{2,30}$/;
